//constants for setting the global curve value of the charts

export const radiusHorizontal = [0, 25, 25, 0] as any;
export const radiusVertical = [25, 25, 0, 0] as any;
